import { apiPath } from "@/api/api-path"
import qs from "qs"
import { DateTime } from "luxon"
import api from "./service"

export async function getEquipment() {
  return api
    .get(apiPath.getEquipment, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getEquipmentById(id) {
  return api
    .get(apiPath.getEquipmentById + id, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getTags() {
  return api
    .get(apiPath.getTags, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDiscoveryBySubnet(subnet) {
  return api
    .get(apiPath.getDiscoveryBySubnet, {
      params: {
        subnet: subnet,
      },
      timeout: 60000,
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      return Promise.reject(error.response.data)
    })
}

export async function addEquipment(request) {
  return api
    .post(apiPath.addEquipment, request, {})
    .then((response) => {
      // code 201 = created successfully
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPolicyName() {
  return api
    .get(apiPath.getPolicyName, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCredentialsSnmp() {
  return api
    .get(apiPath.getCredentialsSnmp, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCredentialsWmi() {
  return api
    .get(apiPath.getCredentialsWmi, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addCredentialsSnmp(request) {
  return api
    .post(apiPath.addCredentialsSnmp, request, {})
    .then((response) => {
      // code 201 = created successfully
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addCredentialsWmi(request) {
  return api
    .post(apiPath.addCredentialsWmi, request, {})
    .then((response) => {
      // code 201 = created successfully
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCredentialsSnmp(id) {
  return api
    .delete(apiPath.deleteCredentialsSnmp + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCredentialsWmi(id) {
  return api
    .delete(apiPath.deleteCredentialsWmi + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPolicyManagementUnits() {
  return api
    .get(apiPath.getPolicyManagementUnits, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPolicyManagement() {
  return api
    .get(apiPath.getPolicyManagement, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addPolicyManagement(request) {
  return api
    .post(apiPath.addPolicyManagement, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPolicyManagementById(id) {
  return api
    .get(apiPath.getPolicyManagementById + id, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updatePolicyManagementById(id, request) {
  return api
    .put(apiPath.getPolicyManagementById + id, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function checkPolicyManagementById(id) {
  return api
    .get(apiPath.checkPolicyManagementById + id + "/check", {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deletePolicyManagementById(id, disableMonitoring) {
  return api
    .delete(
      apiPath.deletePolicyManagementById + id,
      {
        params: {
          disableMonitoring: disableMonitoring,
        },
      },
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getResourceTypes() {
  return api
    .get(apiPath.getResourceTypes, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAlertManagement() {
  return api
    .get(apiPath.getAlertManagement, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAlertManagementById(id) {
  return api
    .get(apiPath.getAlertManagementById + id, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function enableAlertManagementById(id) {
  return api
    .patch(apiPath.enableAlertManagementById + id + "/toggle", {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAlertManagementEquipment() {
  return api
    .get(apiPath.getAlertManagementEquipment, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addAlertManagement(request) {
  return api
    .post(apiPath.addAlertManagement, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateAlertManagementById(id, request) {
  return api
    .put(apiPath.updateAlertManagementById + id, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteAlertManagementById(id) {
  return api
    .delete(apiPath.deleteAlertManagementById + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDashboardCpu() {
  return api
    .get(apiPath.getDashboardCpu, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDashboardMemory() {
  return api
    .get(apiPath.getDashboardMemory, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDashboardStorage() {
  return api
    .get(apiPath.getDashboardStorage, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDashboardEquipmentResource() {
  return api
    .get(apiPath.getDashboardEquipmentResource, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getDashboardEvents(from, to) {
  return api
    .get(apiPath.getEvents, {
      params: {
        from: from,
        to: to,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getGraphCpuStatById(id, datetimeParams) {
  return api
    .get(apiPath.getEquipmentById + id + "/stats/cpu", {
      params: datetimeParams,
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getGraphMemoryStatById(id, datetimeParams) {
  return api
    .get(apiPath.getEquipmentById + id + "/stats/memory", {
      params: datetimeParams,
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getStorageStatById(id, datetimeParams) {
  return api
    .get(apiPath.getEquipmentById + id + "/stats/storage", {
      params: datetimeParams,
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateTagListToSingleEquipment(id, taglist) {
  return api
    .put(apiPath.updateTagListByEquipmentId + id + "/tags", taglist, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateTagListToMultipleEquipment(
  equipmentIds,
  tags,
  overwrite
) {
  return api
    .put(
      apiPath.updateTagList,
      {
        equipmentIds: equipmentIds,
        tags: tags,
        overwrite: overwrite,
      },
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function disablePolicyMonitoringToSingleEquipment(id) {
  return api
    .patch(
      apiPath.disablePolicyMonitoringByEquipmentId + id + "/monitoring/disable",
      null,
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function disablePolicyMonitoringToMultipleEquipment(
  targetDisableMoniteringEquipmentIdList
) {
  return api
    .patch(
      apiPath.disableMultiplePolicyMonitoring,
      { equipmentIds: targetDisableMoniteringEquipmentIdList },
      {}
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updatePolicyToSingleEquipment(id, policy) {
  return api
    .put(apiPath.updatePolicyByEquipmentId + id + "/policy", policy, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updatePolicyToMultipleEquipment(
  equipmentIdList,
  policyId
) {
  return api
    .put(apiPath.updatePolicyMultipleEquipment, {
      equipmentIds: equipmentIdList,
      policyId: policyId,
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAllEvents(from, to, equipments, resourceTypes, tags) {
  return api
    .get(apiPath.getEvents, {
      params: {
        from: from,
        to: to,
        equipments: equipments,
        resourceTypes: resourceTypes,
        tags: tags,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getHostname() {
  return api
    .get(apiPath.getHostname, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getPreviewReport(filter) {
  return api
    .get(apiPath.getReport, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getExportReport(filter) {
  return api
    .get(apiPath.exportReport, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },

      responseType: "blob",
    })
    .then((response) => {
      if (response.status === 200) {
        const href = URL.createObjectURL(response.data)
        const link = document.createElement("a")
        link.href = href
        link.setAttribute(
          "download",
          `Server_Event_${DateTime.now().toFormat("yyyy-MM-dd")}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return response.data
      }
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteEquipmentById(equipmentIdList) {
  return api
    .delete(apiPath.deleteEquipment, {
      data: {
        equipmentIds: equipmentIdList,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}
